import { useEffect, useState, useSyncExternalStore } from 'react';
import { api } from '../lib/auth';
import { getStatus, subscribeStatus } from '../lib/socket';

/** "12 online now": people on the site and games being played, refreshed every 15 seconds. */
export function OnlineNow() {
  const [s, setS] = useState<{ online: number; games: number } | null>(null);
  const conn = useSyncExternalStore(subscribeStatus, getStatus);
  useEffect(() => {
    let alive = true;
    const load = () => api<{ online: number; games: number }>('/stats').then((r) => { if (alive) setS(r); }).catch(() => { if (alive) setS(null); });
    void load();
    const t = setInterval(load, 15_000);
    return () => { alive = false; clearInterval(t); };
    // Reload when our own connection comes up, so we count ourselves.
  }, [conn]);
  if (!s) return null;
  const online = Math.max(1, s.online); // whoever reads this is on the site
  return (
    <div className="online-now" title="Players on the site right now">
      <span className="live-dot green" />
      <b>{online}</b> {online === 1 ? 'player' : 'players'} online
      {s.games > 0 && <span className="muted"> · {s.games} {s.games === 1 ? 'game' : 'games'} running</span>}
    </div>
  );
}
